import { decode } from '@mx/util/decode';
import { objectToQuery } from '@mx/util/object-to-query';

// 从 search 上获取参数
export const getAllQueryStringFromSearch = (search: string) => {
  if (!search) {
    return {};
  }
  const arr = search.substr(1).split('&');
  const result: IStringPropertyStringValue = {};
  for (let i = 0, l = arr.length; i < l; i++) {
    const item = arr[i].split('=');
    const key = item.shift() || '';
    result[key] = decode(item.join('='));
  }
  return result;
};

export const insertUrlParams = (url: string, key: string, value: string) => {
  const urlParse = new URL(url);
  const { origin, pathname, hash, search } = urlParse;

  const paramsArr = getAllQueryStringFromSearch(search);
  paramsArr[key] = value;

  let newSearch = '';
  if (Object.keys(paramsArr).length > 0) {
    newSearch += `?${objectToQuery(paramsArr)}`;
  }
  return origin + pathname + newSearch + hash;
};
